import gql from 'graphql-tag';

import { INVENTORY_OPTION_FRAGMENT } from './fragments';

export const GET_INVENTORY_OPTIONS = gql`
  query InventoryOptions($input: InventoryOptionListInput!) {
    inventoryOptions(input: $input) {
      page
      total
      perPage
      totalPages
      data {
        ...InventoryOptionFields
      }
    }
  }
  ${INVENTORY_OPTION_FRAGMENT}
`;

export const GET_INVENTORY_OPTION_BY_ID = gql`
  query InventoryOptionById($input: InventoryOptionByIdInput!) {
    inventoryOptionById(input: $input) {
      ...InventoryOptionFields
    }
  }
  ${INVENTORY_OPTION_FRAGMENT}
`;

export const GET_INVENTORY_OPTION_EQUIPMENT_ATTRIBUTES = gql`
  query InventoryOptionEquipmentAttributes($accountId: ID!) {
    inventoryOptionEquipmentAttributes(accountId: $accountId) {
      attributes {
        year
        make
        model
        modelBase
      }
    }
  }
`;

export const GET_MATCHING_INVENTORY_OPTIONS = gql`
  query MatchingInventoryOptions($input: MatchingInventoryOptionsInput!) {
    matchingInventoryOptions(input: $input) {
      inventoryOptionId
      code
      name
      description
      cost
      matchedPricing {
        inventoryOptionPricingId
        inventoryOptionId
        year
        make
        model
        modelBase
        cost
      }
    }
  }
`;
